import { z } from 'zod';
import { apiClient } from '../lib/api';
import { ApiResponseSchema } from '../schemas';

const UserInfoSchema = z.object({
	id: z.string(),
	username: z.string(),
	name: z.string(),
	email: z.string().nullable().optional(),
	role: z.string().optional(),
	MaCB: z.string().nullable().optional(),
	maKhoa: z.string().nullable().optional(),
	writable: z.boolean().optional(),
	hasPassword: z.boolean()
}).strip();

export type UserInfo = z.infer<typeof UserInfoSchema>;

export const userApi = {
	async getCurrentUser(): Promise<UserInfo> {
		const response = await apiClient.get('/user/me');
		return ApiResponseSchema(UserInfoSchema).parse(response.data).data;
	},
};
